import './ButtonModule.less';

import clsx from 'clsx';
import React from 'react';
import LinkInterceptor from 'nike-ui/src/components/link-interceptor/LinkInterceptor';

const ButtonModule = function({ url, text, disabled }) {
    return (
        <LinkInterceptor
            href={url}
            children={text}
            className={clsx('nui-button primary button-module-link', {
                'button-module-link-disabled': disabled
            })}
            allowReplace={false}
        />
    );
};

export default ButtonModule;
